import { Collapse, Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import { ReactNode, useMemo } from "react";

import FlexContainer from "../FlexContainer";
import { PrimaryText } from "../Typography/Styled";
import {
    StyledTACollapse,
    StyledTACollapseWrapper,
    StyledTATableWrapper,
    StyledTATotalSumText,
} from "./Styled";

const { Panel } = Collapse;

export interface UniversalAccordionTableProps<T> {
    data: T[];
    columns: ColumnsType<T>;
    getTotalValue?: (data: T[]) => number;
    title?: string | ReactNode;
}

export const TotalAccordion = <T extends { key: React.Key }>({
    data,
    columns,
    getTotalValue,
    title = "Загальна сума",
}: UniversalAccordionTableProps<T>) => {
    const totalValue = useMemo(
        () => getTotalValue?.(data) ?? 0,
        [data, getTotalValue],
    );

    return (
        <StyledTACollapseWrapper>
            <StyledTACollapse>
                <Panel
                    key="1"
                    header={
                        <FlexContainer
                            justifyContent="space-between"
                            width="100%"
                        >
                            <PrimaryText
                                fontSize={14}
                                fontWeight="400"
                                lineHeight="140%"
                            >
                                {title}
                            </PrimaryText>
                            <StyledTATotalSumText>
                                {totalValue.toLocaleString("uk-UA", {
                                    minimumFractionDigits: 2,
                                })}{" "}
                                грн.
                            </StyledTATotalSumText>
                        </FlexContainer>
                    }
                >
                    <StyledTATableWrapper>
                        <Table
                            columns={columns}
                            dataSource={data}
                            pagination={false}
                            bordered
                            rowClassName={() => "custom-row"}
                        />
                    </StyledTATableWrapper>
                </Panel>
            </StyledTACollapse>
        </StyledTACollapseWrapper>
    );
};
